module.exports = __webpack_public_path__ + "assets/img/step4.7c3b5244.jpg";